import Button from "../button/button";

import "./stage.scss";

function Stage(props) {
  return (
    <div className="stage" id="home">
      <div className="stage__image">
        <img src="/images/profil.png" alt="Profilbild von Lennart Kallert" loading="lazy" />
      </div>

      <div className="stage__content">
        <h1 className="stage__headline">Frontend Developer</h1>
        <p className="stage__description">
          Mein Name ist Lennart Kallert,
          <br />
          ich bin freiberuflicher Frontend-Developer aus Hamburg.
        </p>

        <div className="stage__content-buttons">
          <Button
            text="Kontakt"
            onClick={() => {
              const target = document.getElementById("contact");

              if (target) {
                target.scrollIntoView({ behavior: "smooth" });
              }
            }}
            ariaLabel="Scrollt in den Kontaktbereich"
          />
        </div>
      </div>
    </div>
  );
}

export default Stage;
